import React, { createContext, useContext, useState } from 'react';

const UserContext = createContext();

export const useUserContext = () => useContext(UserContext);

export const UserProvider = ({ children, initialData = {} }) => {
  const [userData, setUserData] = useState(initialData);
  const [selectedBot, setSelectedBot] = useState(
    localStorage.getItem('selectedBot')
  );
  const updateProfileImage = (file, userId, updates = {}) => {
    if (!file) {
      setUserData((prev) => ({
        ...prev,
        ...updates,
      }));
      return;
    }

    const reader = new FileReader();
    reader.onloadend = () => {
      const base64String = reader.result.split(',')[1];
      setUserData((prev) => ({
        ...prev,
        userImage: {
          userId: userId || prev?.userImage?.userId,
          userImage: base64String,
        },
        ...updates,
      }));
    };

    reader.readAsDataURL(file);
  };

  return (
    <UserContext.Provider
      value={{
        userData,
        setUserData,
        updateProfileImage,
        selectedBot,
        setSelectedBot,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};
